import { FieldModel } from '@cibo/core'
import { LivestockCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface LivestockCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
}

export const LivestockCell = ({ value, task, year, selectedField }: LivestockCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="livestock"
    >
      <LivestockCellDisplay value={value} />
    </TraitCellContainer>
  )
}
